import styled from 'styled-components';

export const Container = styled.div`
    transition: all 0.5s;
    &:hover {
        opacity: 0.75;
    }
`;



// WEBPACK FOOTER //
// ./src/UI/Components/HoverableFadingContainer/style.js